<div class="pe-page">

 
  <!-- ── Page header ── -->
  <div class="pe-header">
    <div class="pe-header-left">
      <a routerLink="/projects" class="back-link">
        <mat-icon>arrow_back</mat-icon> Projects
      </a>
      <h1 class="pe-title">{{ project?.title || 'Project' }}</h1>
    </div>
    <button mat-raised-button color="primary" (click)="saveProject()" class="save-btn">
      <mat-icon>save</mat-icon> Save
    </button>
  </div>

  <!-- ── Stats grid ── -->
  <div class="pe-stats">
    <div class="stat-card stat-red">
      <div class="stat-value">{{ project?.totalProjectPrice | currency }}</div>
      <div class="stat-label">Total Price</div>
    </div>
    <div class="stat-card stat-blue">
      <div class="stat-value">{{ project?.currentProjectPrice | currency }}</div>
      <div class="stat-label">Current Spend</div>
    </div>
    <div class="stat-card stat-navy stat-clickable" (click)="tabGroup.selectedIndex = 1" title="Go to Labor">
      <div class="stat-value">{{ project?.totalLaborPrice | currency }}</div>
      <div class="stat-label">Labor <mat-icon class="link-icon">open_in_new</mat-icon></div>
    </div>
    <div class="stat-card stat-gray stat-clickable" (click)="tabGroup.selectedIndex = 0" title="Go to Materials">
      <div class="stat-value">{{ project?.totalMaterialPrice | currency }}</div>
      <div class="stat-label">Materials <mat-icon class="link-icon">open_in_new</mat-icon></div>
    </div>
    <div class="stat-card stat-green stat-clickable" (click)="tabGroup.selectedIndex = 3" title="Go to Tasks">
      <div class="stat-value">{{ projecTasksCount }}</div>
      <div class="stat-label">Tasks <mat-icon class="link-icon">open_in_new</mat-icon></div>
    </div>
    <div class="stat-card stat-teal">
      <div class="stat-value">2</div>
      <div class="stat-label">Remaining Payments</div>
    </div>
    <div class="stat-card stat-steelblue stat-clickable" (click)="tabGroup.selectedIndex = 6" title="Go to Contractors">
      <div class="stat-value">{{ projecContractorsCount ?? '—' }}</div>
      <div class="stat-label">Contractors <mat-icon class="link-icon">open_in_new</mat-icon></div>
    </div>
    <div class="stat-card stat-purple stat-clickable" (click)="tabGroup.selectedIndex = 7" title="Go to Notes">
      <div class="stat-value">{{ projectNotesCount ?? '—' }}</div>
      <div class="stat-label">Notes <mat-icon class="link-icon">open_in_new</mat-icon></div>
    </div>
  </div>

  <!-- ── Edit form ── -->
  <div class="pe-form-card">
    <h3 class="section-title">Project Details</h3>
    <form [formGroup]="form" class="pe-form">
      <mat-form-field appearance="outline" class="pe-field">
        <mat-label>Project Name</mat-label>
        <input matInput formControlName="title" required>
      </mat-form-field>

      <mat-form-field appearance="outline" class="pe-field pe-field-wide">
        <mat-label>Description</mat-label>
        <input matInput formControlName="projectDescription" required>
      </mat-form-field>

      <mat-form-field appearance="outline" class="pe-field">
        <mat-label>Priority</mat-label>
        <input matInput formControlName="priority">
      </mat-form-field>

      <div class="pe-field pe-toggle-field">
        <mat-slide-toggle formControlName="isActive" color="primary">
          {{ form.get('isActive')?.value ? 'Active' : 'Inactive' }}
        </mat-slide-toggle>
        <div class="pe-toggle-hint">
          Inactive projects are hidden from active resource planning.
        </div>
      </div>

      <div class="pe-field pe-toggle-field">
        <mat-slide-toggle formControlName="isComplete" color="accent">
          {{ form.get('isComplete')?.value ? 'Completed' : 'In Progress' }}
        </mat-slide-toggle>
        <div class="pe-toggle-hint">
          Completed projects appear in the Completed Projects section.
        </div>
      </div>
    </form>
  </div>

  <!-- ── Tabs ── -->
  <div class="pe-tabs-wrap">
    <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)">

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">construction</mat-icon>
          <span class="tab-label">Material</span>
        </ng-template>
        <app-project-material [project]="project"></app-project-material>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">engineering</mat-icon>
          <span class="tab-label">Labor</span>
        </ng-template>
        <app-project-labor [project]="project" (paidStatusChanged)="onLaborPaidChanged()"></app-project-labor>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">calendar_month</mat-icon>
          <span class="tab-label">Schedule</span>
        </ng-template>
        <app-project-schedule [project]="project"></app-project-schedule>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">event_note</mat-icon>
          <span class="tab-label">Tasks</span>
        </ng-template>
        <app-project-task-grid [project]="project"></app-project-task-grid>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">photo_library</mat-icon>
          <span class="tab-label">Photos</span>
        </ng-template>
        <app-project-image></app-project-image>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">draw</mat-icon>
          <span class="tab-label">Drawings</span>
        </ng-template>
        <div class="tab-content-pad">
          <button mat-raised-button (click)="openDrawingUpload()">
            <mat-icon>upload</mat-icon> Add Drawing
          </button>
          <app-project-drawing></app-project-drawing>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">groups</mat-icon>
          <span class="tab-label">Contractors</span>
        </ng-template>
        <app-project-contractors></app-project-contractors>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">notes</mat-icon>
          <span class="tab-label">Notes</span>
        </ng-template>
        <app-notes></app-notes>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">front_loader</mat-icon>
          <span class="tab-label">Equipment</span>
        </ng-template>
        <app-project-equipment-grid></app-project-equipment-grid>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">assignment</mat-icon>
          <span class="tab-label">Daily Reports</span>
        </ng-template>
        <app-project-daily-report [project]="project"></app-project-daily-report>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">quiz</mat-icon>
          <span class="tab-label">RFIs</span>
        </ng-template>
        <app-project-rfi [project]="project"></app-project-rfi>
      </mat-tab>

    </mat-tab-group>
  </div>

</div>
